<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Usuwanie folderu
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                {{ formattedTitle }}
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="info"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Usuń"
                    :loading="actionLoading"
                    @click="deleteProcessSubject(processSubject)"
                >
                    Usuń
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'DeleteProcessSubjectDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        processSubject: {
            type: Object,
            default: null
        },
        actionLoading: {
            type: Boolean
        },
    },
    computed: {
        formattedTitle() {
            return this.processSubject.offspringsIds?.length > 0
                ? 'Uwaga! Folder zawiera podfoldery lub wpisy. Czy na pewno chcesz usunąć folder wraz z całą zawartością?'
                : 'Czy na pewno chcesz usunąć folder?'
        }
    },
    methods: {
        deleteProcessSubject(processSubject) {
            this.$emit('on-confirm', processSubject)
            this.onClose()
        },
        onClose() {
            this.$emit('on-close')
        },
    }
}
</script>

